const TibetSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112542)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.72803 3.47828C11.9378 1.28406 15.8189 0 20.0004 0C24.182 0 28.0631 1.28406 31.2729 3.47828L20.0004 4.34781L8.72803 3.47828Z"
        fill="#FFDA44"
      />
      <path
        d="M5.85891 34.1413L15.0809 24.9195L20 16.522L24.9185 24.9189L34.1411 34.1413C37.7606 30.5223 40 25.5231 40 20.0002C40 13.1361 36.5415 7.08031 31.2724 3.47852H8.72758C3.45852 7.08031 0 13.1361 0 20.0002C0 25.5231 2.23938 30.5223 5.85891 34.1413Z"
        fill="#D80027"
      />
      <path
        d="M38.4811 27.6569L23.8584 21.5977L24.9182 24.9167L34.1415 34.14C35.9831 32.2987 37.4673 30.1001 38.4811 27.6569Z"
        fill="#0052B4"
      />
      <path
        d="M40 19.9997C40 17.2868 39.4593 14.7005 38.4806 12.3418L20 19.9997H40Z"
        fill="#0052B4"
      />
      <path
        d="M34.1411 5.85914C33.262 4.98023 32.302 4.18234 31.2724 3.47852H26.8462L20 20.0002L34.1411 5.85914Z"
        fill="#0052B4"
      />
      <path d="M19.9995 3.47852H13.1533L19.9995 20.0002V3.47852Z" fill="#0052B4" />
      <path
        d="M5.85947 5.85938C4.01791 7.70078 2.53377 9.8993 1.52002 12.3425L20.0006 20.0005L5.85947 5.85938Z"
        fill="#0052B4"
      />
      <path d="M0 20C0 22.7129 0.540703 25.2992 1.51937 27.6579L20 20H0Z" fill="#0052B4" />
      <path
        d="M8.72803 36.5215C11.9377 38.7157 15.8189 39.9998 20.0004 39.9998C24.182 39.9998 28.0631 38.7157 31.2729 36.5215H8.72803Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 19.9995L24.9189 24.9184C26.1779 23.6595 26.9565 21.9205 26.9565 19.9995C26.9565 16.1574 23.842 13.043 20 13.043C16.1581 13.043 13.0435 16.1574 13.0435 19.9995C13.0435 21.9204 13.8221 23.6595 15.081 24.9184L19.9999 19.9995Z"
        fill="#FFDA44"
      />
      <path
        d="M23.0436 30.0005C23.0436 31.6814 21.6808 32.1745 20.0001 32.1745C18.3193 32.1745 16.9565 31.6814 16.9565 30.0005C16.9565 28.3197 18.3193 26.957 20.0001 26.957C21.6808 26.957 23.0436 28.3197 23.0436 30.0005Z"
        fill="#FFDA44"
      />
      <path
        d="M23.0436 30C23.0436 31.6809 21.6808 33.0435 20.0001 33.0435C18.3193 33.0435 16.9565 31.6809 16.9565 30"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112542">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TibetSvg;
